import { StyleSheet } from 'react-native';
import React, { useEffect, useState } from "react";
import { PlaceholderContainer } from "placeholders";
import FetchStatistics from "utils/fetch/FetchStatistics";
import ThemedBlock from "components/atoms/ThemedBlock";
import ManagementThemedTable from "components/management/molecules/ManagementThemedTable";
import Button from "theme/Button";
import i18n from "utils/i18n";
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import Title from 'components/atoms/Title'
import Description from 'components/atoms/Description'
import LoadingComponent from 'components/atoms/Loading'
import { StatisticTables } from 'scenes/management/statistics/data/tables'
import HelperString from 'utils/helper-string'
import { useNavigation } from '@react-navigation/native'
import { Column, Grid, Row } from 'components/atoms/BootstrapGrid'

const ManagementStatisticsStatisticsTable = ({ statistic }) => {
	
	const navigation = useNavigation();
	
	const [ loading, setLoading ] = useState( true )
	const [ data, setData ] = useState( null )

	const fetchStatistics = () => {
		FetchStatistics.fetch([ statistic.identifier ], {
			callbackSuccess: ( result ) => {
				const data = JSON.parse( result[ 0 ].data );
				
				setData( data )
				setLoading( false )
			}
		});
	}
	
	const onPress = () => {
		let next_statistic_identifier = _.get( statistic, 'details', null );
		const next_statistic = StatisticTables[ next_statistic_identifier ];
		
		navigation.navigate( AppRoutes[ `MANAGEMENT_STATISTICS_DETAILS_${next_statistic.depth + 1}` ], {
			statistics: next_statistic.identifier
		});
	}
	
	useEffect( () => {
		fetchStatistics();
	}, [] )

	if( loading === true ) {
		return (
			<PlaceholderContainer>
				<LoadingComponent />
			</PlaceholderContainer>
		);
	}
	
	const identifier = statistic.identifier;
	const onPressDetails = _.get( statistic, 'details', null ) !== null;
	const headers = _.map( statistic.headers, header => {
		return i18n.t(`management:statistics.general.${header}`);
	});
	
	return (
		<ThemedBlock
			key={ HelperString.hash( 'ManagementStatisticsStatisticsTable', statistic.identifier ) }
			mediumPadding
			shadow>

			<Grid>
				<Row>
					<Column span={75}>
						{ i18n.exists(`management:statistics.${identifier}.title`) && (
							<Title>
								{ i18n.t(`management:statistics.${statistic.identifier}.title`) }
							</Title>
						)}

						{ i18n.exists(`management:statistics.${identifier}.description`) && (
							<Description>
								{ i18n.t(`management:statistics.${statistic.identifier}.description`) }
							</Description>
						)}
					</Column>
					<Column span={25}>
						{ onPressDetails && (
							<Button
								onPress={ onPress }
								size={"small"}
								appearance={ "ghost" }
								style={ staticStyles.buttonMarginBottom10}>
								
								{i18n.t('management:pages.statistics.index.btn_details')}
							</Button>
						)}
					</Column>
				</Row>
			</Grid>

			<ManagementThemedTable
				headers={ headers }
				rows={ data }
			/>
		</ThemedBlock>
	);
}

const staticStyles = StyleSheet.create({
	buttonMarginBottom10: {
		marginBottom: 10,
	},
});

export default ManagementStatisticsStatisticsTable
